export default __webpack_public_path__ + "static/media/si.17afd197.png";